import ServiceCaller from "../../services/ServiceCaller";
import ClientService from "../../services/Client";
const service = new ClientService()

// Load user information
const state = {
  error: "",
  inProgress: false,
  userClients: null,
  authorizeResponse: null,
  authorizeError: "",
  revokeResponse: null,
  revokeError: "",
  updateResponse: null,
  updateError: "",
}
const mutations = {
  setError: (state, value) => {state.error = value},
  setInProgress: (state, value) => {state.inProgress = value},
  setUserClients: (state, value) => {state.userClients = value},
  setAuthorizeResponse: (state, value) => {state.authorizeResponse = value},
  setAuthorizeError: (state, value) => {state.authorizeError = value},
  setRevokeResponse: (state, value) => {state.revokeResponse = value},
  setRevokeError: (state, value) => {state.revokeError = value},
  setUpdateResponse: (state, value) => {state.updateResponse = value},
  setUpdateError: (state, value) => {state.updateError = value},

}
const actions = {
  loadUserClients: (context) => ServiceCaller.call(service.getUserClients(), context.commit, 'setUserClients', 'setError', 'setInProgress'),
  authorize: (context, payload) => ServiceCaller.call(service.authorizeClient(payload.activationCode, payload.elevatedAccess), context.commit, 'setAuthorizeResponse', 'setAuthorizeError', 'setInProgress'),
  revoke: (context, clientID) => ServiceCaller.call(service.revokeClient(clientID), context.commit, 'setRevokeResponse', 'setRevokeError', 'setInProgress'),
  update: (context, payload) => ServiceCaller.call(service.updateClient(payload.ID, payload), context.commit, 'setUpdateResponse', 'setUpdateError', 'setInProgress', true),

}

const getters = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
